import { contains, map, scan } from "@pdfking/rfunc"
import { url_parse } from "@pdfking/workflow/utils/urlutilities"
import virtual from "@pdfking/workflow/vue/3/virtual"

import selector from "../dom/selector"
import toggle_class from "../dom/toggle_class"
import register_dom_update from "../navigation/register_dom_update"

const BREADCRUMB_SELECTOR =
  ".breadcrumb-item a[href], .breadcrumb-item meta[content][itemprop=item]"

const BREADCRUMB_UPDATE_SELECTOR = ".breadcrumb-active"
const BREADCRUMB_CLASS = "active"

const state = virtual({
  data: () => ({ links: [] }),
  mounted() {
    this.populate_links()
  },
  methods: {
    populate_links() {
      const elements = map(
        e =>
          url_parse(e.getAttribute("href") || e.getAttribute("content"))
            .pathname,
        selector(BREADCRUMB_SELECTOR)
      )
      elements.reverse()
      scan(
        e =>
          toggle_class(e, {
            [BREADCRUMB_CLASS]: contains(elements, url_parse(e.href).pathname),
          }),
        selector(BREADCRUMB_UPDATE_SELECTOR)
      )

      this.links = elements
    },
  },
})

export default state

register_dom_update({
  after: () => state.populate_links(),
})
